import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { Jwt } from '../models/jwt.model';
import { BaseResponse, PaginatedBaseResponse } from '../models/base-response.model';
import { User, AuthenticatedUser } from 'src/app/users/models/user.model';
import { JwtService } from './jwt.service';
import { Role } from 'src/app/users/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  createUser(newUser:any): Observable<any>{
    let body =JSON.stringify(newUser);
    const httpOptions: { headers: any; observe: any; } = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }),
          observe: 'response' 
        };
        return this._http.post(this.uri+ '/user', body, httpOptions);
  } 


  private uri: string = environment.url;
  private username: string = environment.key_username;
  private password: string = environment.key_password;
  private grantTypePassword: string = environment.grant_type;
  private grantTypeCC: string = environment.grant_type_cc;
  private userSource = new BehaviorSubject<undefined|User>(undefined);
  public userObserver = this.userSource.asObservable();
  private userProfileSource = new BehaviorSubject<undefined|User>(undefined);
  public userProfileObserver = this.userProfileSource.asObservable();



  public textPattern = new RegExp("^[A-Za-z0-9'@#$%^&*()/.()_\-]+$");
  public namePattern = new RegExp("^[A-Za-z'_ \-]+$");
  public companyReg = new RegExp('^[A-Za-z]{1,3}[0-9\/.*\\ ]+$');
  public emailPattern =  new RegExp("^[A-Za-z0-9'@#$%^&*()/.()_\-]+$");
  public multiAlphaNumeric = new RegExp('^[A-Za-z0-9@#$%^&*()_ ]+$');
  public nameNumberSpace = new RegExp('^[A-Za-z0-9 ]+$');
  public number = new RegExp('^[0-9]+$');
  public phonePattern = new RegExp('^[0-9+]+$');
  public mobileNoPattern = new RegExp('^[0-9]{10,15}$');
  token: any;
  helper: any;

  constructor(private _http: HttpClient, private _jwtService: JwtService) { }

  public currentUser(): AuthenticatedUser {
    const user: AuthenticatedUser = this._jwtService?.token?.user;
    return user;
  }

  public get isAdmin(): boolean {
    const role: Role | undefined = this.currentUser()?.roles?.find((role: Role) => role.name == 'ADMIN') ?? undefined;
    return role != undefined;
  }

  public get isUser(): boolean {
    const role: Role | undefined = this.currentUser()?.roles?.find((role: Role) => role.name == 'USER') ?? undefined;
    return role != undefined;
  }

  public get isRegionalManager(): boolean {
    const role: Role | undefined = this.currentUser()?.roles?.find((role: Role) => role.name == 'REGIONAL MANAGER') ?? undefined;
    return role != undefined;
  }

  public get isReporter(): boolean {
    const role: Role | undefined = this.currentUser()?.roles?.find((role: Role) => role.name == 'REPORTER') ?? undefined;
    return role != undefined;
  }

  public signinByClientCredentials(): Observable<Jwt> {
    //header
    const signInHeaders = new HttpHeaders({
      'Authorization': 'Basic ' + btoa(this.username + ":" + this.password),
      "Content-Type": "application/x-www-form-urlencoded"
    });
    //parameters
    const parameters = new HttpParams()
      .set('grant_type', this.grantTypeCC);
    let options = { headers: signInHeaders, params: parameters };

    return this._http.post<Jwt>(this.uri + "/authenticate", null, options);
  }

  public signin(username: string, password: string): Observable<Jwt> {
    //header
    const signInHeaders = new HttpHeaders({
      'Authorization': 'Basic ' + btoa(this.username + ":" + this.password),
      "Content-Type": "application/x-www-form-urlencoded"
    });
    //parameters
    const parameters = new HttpParams()
      .set('grant_type', this.grantTypePassword)
      .set('username', username)
      .set('password', password);
    let options = { headers: signInHeaders, params: parameters };

    return this._http.post<Jwt>(this.uri + "/authenticate", {username, password}, options);
  }

  public forgotPassword(accessToken: string, email: string): Observable<any> {
    //header
    const headers = new HttpHeaders({
      "Authorization": 'Bearer ' + accessToken,
      "Accept": 'application/json'
    });

    //parameters
    const params = new HttpParams()
      .set('email_address', email);

    const options = { headers, params };

    return this._http.post<any>(`${this.uri}/user/forgotPassword`, null, options);
  }

  public setPassword(accessToken: string, password: string, token: string | null): Observable<BaseResponse<{ first_name: string, username: string }>> {

    //header
    const headers = new HttpHeaders({
      "Authorization": 'Bearer ' + accessToken,
      "Accept": 'application/json'
    });

    let request = {
      'password': password,
      'token': token
    };

    return this._http.post<BaseResponse<{ first_name: string, username: string }>>(`${this.uri}/user/resetPassword`, request, { headers });
  }

  public find(query: { page?: string, pageSize?: string, emailAddress?: string, id?: string }): Observable<PaginatedBaseResponse<User[]>> {
    const { page, pageSize, emailAddress, id } = query;
    let params = new HttpParams()
      .set('id', id ? id : '')
      .set('email_address', emailAddress ? emailAddress : '')
      .set('page', page ? page : '')
      .set('page_size', pageSize ? pageSize : '');
    return this._http.get<PaginatedBaseResponse<User[]>>(`${this.uri}/user`, { params });
  }

  getUser(userId: string) {
    const href = `${this.uri}/user`;
    const requestUrl = `${href}?id=${userId}`;
    //return this.http.get<McrbApi>(requestUrl, { observe: 'response' });
    return this._http.get<PaginatedBaseResponse<User[]>>(requestUrl);
  }

  getUserDetails():User{
    //console.log(<AuthUserDetails>(this.getToken()));
    return <User>(this.getToken());
  }
  getToken():any{
    return this.helper.decodeToken(this.token.access_token).user
  }

  public set userProfile(user: User) {
    this.userProfileSource.next(user);
  }
  public create(user: User): Observable<BaseResponse<any>> {
    return this._http.post<any>(`${this.uri}/user`, user);
  }

  public update(user: User): Observable<BaseResponse<any>> {
    return this._http.put<any>(`${this.uri}/user`, user);
  }
  getUserNames(): string{
    return this.getUserDetails().first_name + " " + this.getUserDetails().last_name;
  }

  // getFirstName(): string{
  //   return this.getUserDetails().first_name;
  // }

  // getRolesList(): Array<undefined|Role>{
  //   return this.getUserDetails().roles;
  // }
}
